import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  cacheKey: '',
  value: null,
  isEmpty: false,
  isSearching: false,
  error: null,
}

const setCacheKeyHandler = (state, { payload }) => {
  state.cacheKey = String(payload ?? '')
}

const searchRequestHandler = state => {
  state.isSearching = true
  state.value = null
  state.isEmpty = false
  state.error = null
}

const searchSuccessHandler = (state, { payload }) => {
  state.isSearching = false
  state.value = payload?.value ?? null
  state.isEmpty = false
  state.error = null
}

const searchEmptyHandler = state => {
  state.isSearching = false
  state.value = null
  state.isEmpty = true
  state.error = null
}

const searchFailureHandler = (state, { payload }) => {
  state.isSearching = false
  state.value = null
  state.isEmpty = false
  state.error = payload || 'Error'
}

const resetHandler = state => {
  Object.assign(state, initialState)
}

const slice = createSlice({
  name: 'cacheTools',
  initialState,
  reducers: {
    setCacheKey: setCacheKeyHandler,
    searchRequest: searchRequestHandler,
    searchSuccess: searchSuccessHandler,
    searchEmpty: searchEmptyHandler,
    searchFailure: searchFailureHandler,
    reset: resetHandler,
  },
})

export const { setCacheKey, searchRequest, searchSuccess, searchEmpty, searchFailure, reset } = slice.actions

export default slice.reducer
